import React from 'react'
import { ModalBody, Form, FormGroup, ModalFooter } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import ErrorBoundary from '@/components/ErrorBoundary'
import Resx from '@/components/Resx'

const GeneratedPatTokenDialog = (props) => {
  return (
    <React.Fragment>
      <BasicHeader title='Security.PersonalAccessToken' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <h5><Resx name='Security.GeneratedToken' /></h5>
            <FormGroup>
              <textarea onChange={() => {}} value={props.token} rows='4' className='form-control token-textarea' />
            </FormGroup>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ModalFooter />
    </React.Fragment>
  )
}

export default {
  component: GeneratedPatTokenDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/generatedPatToken.js